import {AdGroupBean} from 'common/api/api'
import {FC} from 'react'
import {DictionarySelector, DictionarySelectorProps, enumToLabelValue} from './DictionarySelector'
import ConnectionTypesEnum = AdGroupBean.ConnectionTypesEnum

export const ConnectionTypeSelector: FC<DictionarySelectorProps> = (props) =>
    <DictionarySelector {...props} cacheKey="connectionType" loader={() => enumToLabelValue(ConnectionTypesEnum)} mode="multiple"/>